import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode, Fragment, createCommentVNode, toDisplayString, createVNode, createBlock, resolveDynamicComponent, withCtx, createTextVNode, normalizeStyle, renderList, mergeProps } from 'vue';
import _sfc_main$4 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es112.js';
/* empty css                        */
import RenderlessComponent from './basler-components.es275.js';

const _hoisted_1 = { class: "login-quick-view__inner" };
const _hoisted_2 = { class: "login-quick-view__scrollbox" };
const _hoisted_3 = {
  key: 0,
  class: "login-quick-view__profile"
};
const _hoisted_4 = {
  key: 0,
  class: "login-quick-view__profile-company"
};
const _hoisted_5 = {
  key: 1,
  class: "login-quick-view__profile-row"
};
const _hoisted_6 = { class: "login-quick-view__profile-wrapper" };
const _hoisted_7 = { class: "login-quick-view__profile-name" };
const _hoisted_8 = {
  key: 0,
  class: "login-quick-view__profile-email"
};
const _hoisted_9 = {
  key: 2,
  class: "login-quick-view__seperator"
};
const _hoisted_10 = {
  key: 1,
  class: "login-quick-view__list-item-icon-placeholder"
};
const _hoisted_11 = { class: "login-quick-view__list-item-text-wrapper" };
const _hoisted_12 = { class: "login-quick-view__list-item-text" };
const _hoisted_13 = {
  key: 4,
  class: "login-quick-view__footer"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  key: 1,
  class: "login-quick-view__cta-list"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "LoginQuickView",
  props: {
    isOpen: { type: Boolean, default: false },
    isLoggedIn: { type: Boolean, default: false },
    introText: {},
    profile: {},
    linkGrid: {},
    linkList: {},
    footer: {},
    ctaLinks: {}
  },
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const initials = computed(() => {
      if (props.profile && props.profile.firstName && props.profile.lastName) {
        return `${props.profile.firstName.charAt(0)}${props.profile.lastName.charAt(0)}`;
      }
      return "";
    });
    const atLeastOneListItemHasIcon = computed(() => {
      return props.linkList?.some((item) => item.icon);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["login-quick-view", { "is-open": _ctx.isOpen }])
      }, [
        _cache[6] || (_cache[6] = createElementVNode("div", { class: "login-quick-view__arrow" }, null, -1)),
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            _ctx.isLoggedIn ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              _ctx.profile ? (openBlock(), createElementBlock("div", _hoisted_3, [
                _ctx.profile.company ? (openBlock(), createElementBlock("div", _hoisted_4, toDisplayString(_ctx.profile.company), 1)) : createCommentVNode("", true),
                _ctx.profile.firstName && _ctx.profile.lastName ? (openBlock(), createElementBlock("div", _hoisted_5, [
                  createVNode(_sfc_main$1, {
                    initials: initials.value,
                    size: 40
                  }, null, 8, ["initials"]),
                  createElementVNode("div", _hoisted_6, [
                    createElementVNode("div", _hoisted_7, [
                      (openBlock(), createBlock(resolveDynamicComponent(_ctx.profile.link ? _sfc_main$2 : RenderlessComponent), {
                        link: _ctx.profile.link,
                        onClick: _cache[0] || (_cache[0] = ($event) => emit("navigate"))
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.profile.firstName) + " " + toDisplayString(_ctx.profile.lastName), 1)
                        ]),
                        _: 1
                      }, 8, ["link"]))
                    ]),
                    _ctx.profile.email ? (openBlock(), createElementBlock("div", _hoisted_8, toDisplayString(_ctx.profile.email), 1)) : createCommentVNode("", true)
                  ])
                ])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true),
              _ctx.linkGrid && _ctx.linkGrid.items && _ctx.linkGrid.items.length > 0 ? (openBlock(), createElementBlock("ul", {
                key: 1,
                class: "login-quick-view__link-grid",
                style: normalizeStyle({ "--grid-cols": _ctx.linkGrid.numberOfColumns || 3 })
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.linkGrid.items, (linkItem) => {
                  return openBlock(), createElementBlock("li", {
                    key: linkItem.title,
                    class: "login-quick-view__link-grid-item"
                  }, [
                    linkItem.link && linkItem.title ? (openBlock(), createBlock(_sfc_main$2, {
                      key: 0,
                      link: linkItem.link,
                      class: normalizeClass(["login-quick-view__link-grid-item-link", { "is-placeholder": linkItem.isPlaceholder }]),
                      onClick: _cache[1] || (_cache[1] = ($event) => emit("navigate"))
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$3, {
                          name: linkItem.icon?.name || "more",
                          class: "login-quick-view__link-grid-item-icon"
                        }, null, 8, ["name"]),
                        createElementVNode("span", {
                          class: normalizeClass(["login-quick-view__link-grid-item-text", { "visually-hidden": linkItem.hideTitle }])
                        }, toDisplayString(linkItem.title), 3)
                      ]),
                      _: 2
                    }, 1032, ["link", "class"])) : createCommentVNode("", true)
                  ]);
                }), 128))
              ], 4)) : _ctx.profile ? (openBlock(), createElementBlock("hr", _hoisted_9)) : createCommentVNode("", true),
              _ctx.linkList && _ctx.linkList.length > 0 ? (openBlock(), createElementBlock("ul", {
                key: 3,
                class: normalizeClass(["login-quick-view__list", { "has-items-with-icons": atLeastOneListItemHasIcon.value }])
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.linkList, (linkItem) => {
                  return openBlock(), createElementBlock("li", {
                    key: linkItem.title,
                    class: "login-quick-view__list-item"
                  }, [
                    linkItem.link && linkItem.title ? (openBlock(), createBlock(_sfc_main$2, {
                      key: 0,
                      link: linkItem.link,
                      class: "login-quick-view__list-item-link",
                      onClick: _cache[2] || (_cache[2] = ($event) => emit("navigate"))
                    }, {
                      default: withCtx(() => [
                        linkItem.icon ? (openBlock(), createBlock(_sfc_main$3, mergeProps({
                          key: 0,
                          ref_for: true
                        }, linkItem.icon, { class: "login-quick-view__list-item-icon" }), null, 16)) : atLeastOneListItemHasIcon.value ? (openBlock(), createElementBlock("span", _hoisted_10)) : createCommentVNode("", true),
                        createElementVNode("span", _hoisted_11, [
                          createElementVNode("span", _hoisted_12, toDisplayString(linkItem.title), 1),
                          linkItem.badge ? (openBlock(), createBlock(_sfc_main$4, mergeProps({
                            key: 0,
                            ref_for: true
                          }, linkItem.badge, { class: "login-quick-view__list-item-badge" }), {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(linkItem.badge.slot), 1)
                            ]),
                            _: 2
                          }, 1040)) : createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["link"])) : createCommentVNode("", true)
                  ]);
                }), 128))
              ], 2)) : createCommentVNode("", true),
              _ctx.footer ? (openBlock(), createElementBlock("div", _hoisted_13, [
                _cache[5] || (_cache[5] = createElementVNode("hr", { class: "login-quick-view__seperator" }, null, -1)),
                _ctx.footer.linkItem ? (openBlock(), createBlock(_sfc_main$2, {
                  key: 0,
                  link: _ctx.footer.linkItem.link,
                  class: "login-quick-view__footer-link",
                  onClick: _cache[3] || (_cache[3] = ($event) => emit("navigate"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.footer.linkItem.title), 1)
                  ]),
                  _: 1
                }, 8, ["link"])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              _ctx.introText ? (openBlock(), createElementBlock("div", {
                key: 0,
                innerHTML: _ctx.introText,
                class: "login-quick-view__intro-text"
              }, null, 8, _hoisted_14)) : createCommentVNode("", true),
              _ctx.ctaLinks ? (openBlock(), createElementBlock("ul", _hoisted_15, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.ctaLinks, (ctaLink) => {
                  return openBlock(), createElementBlock("li", {
                    key: ctaLink.title,
                    class: "login-quick-view__cta-list-item"
                  }, [
                    ctaLink.link && ctaLink.title ? (openBlock(), createBlock(_sfc_main$2, mergeProps({
                      key: 0,
                      ref_for: true
                    }, ctaLink, {
                      class: "login-quick-view__cta-list-item-link",
                      onClick: _cache[4] || (_cache[4] = ($event) => emit("navigate"))
                    }), {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(ctaLink.title), 1)
                      ]),
                      _: 2
                    }, 1040)) : createCommentVNode("", true)
                  ]);
                }), 128))
              ])) : createCommentVNode("", true)
            ], 64))
          ])
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
